<div class="card">
  <div class="card-header">
    <div>    
      <ng-container
        *ngIf="deliverySummary?.collectOrder && deliverySummary?.collectOrder?.toLowerCase() == 'yes'; else changeLabel">
        COLLECTION ADDRESS    
      </ng-container>
      <ng-template #changeLabel>
        DELIVERY ADDRESS
      </ng-template>
    </div>
    <a class="editIcon" *ngIf="enableEdit" (click)="editDelivery()">
      <!-- <img src="/images/new_ui/catalogues-edit.png" alt="Edit Delivery Address"> -->
      <span class="basic-icon edit-icon"></span>
    </a>
  </div>
  <div class="card-body">
    
    <ng-container *ngIf="deliverySummary?.collectOrder && deliverySummary?.collectOrder?.toLowerCase() == 'yes';else collectOrder">
      <div class="detail">
        <span *ngIf="deliverySummary?.WarehouseName">{{deliverySummary.WarehouseName}}<br /></span>
        <span *ngIf="deliverySummary?.fullName">{{deliverySummary.fullName}}<br /></span>
        <span *ngIf="deliverySummary?.companyName">{{deliverySummary.companyName}}<br /></span>
        <span *ngIf="deliverySummary?.attnRef && deliveryPickup === 'delivery'">ATTN: {{deliverySummary.attnRef}}<br /></span>
        <span *ngIf="deliverySummary?.addressLine1">{{deliverySummary.addressLine1}}<br /></span>
        <span *ngIf="deliverySummary?.addressLine2">{{deliverySummary.addressLine2}}<br /></span>
        <span *ngIf="deliverySummary?.addressLine3">{{deliverySummary.addressLine3}}<br /></span>
        <span *ngIf="deliverySummary?.suburb">{{deliverySummary.suburb}}<br /></span>
        <span *ngIf="deliverySummary?.state">{{deliverySummary.state}}</span> <span *ngIf="deliverySummary?.postcode"> {{deliverySummary.postcode}}</span>
      </div>
    </ng-container>

    <ng-template #collectOrder>
     <!--  <br>
      <span>Desired dispatch date: {{deliverySummary.dispatchDate}}</span> -->
      <div class="detail">       
        <span *ngIf="deliverySummary?.fullName">{{deliverySummary.fullName}}<br /></span>
        <span *ngIf="deliverySummary?.companyName">{{deliverySummary.companyName}}<br /></span>
        <span *ngIf="deliverySummary?.attnRef">ATTN: {{deliverySummary.attnRef}}<br /></span>
        <span *ngIf="deliverySummary?.addressLine1">{{deliverySummary.addressLine1}}<br /></span>
        <span *ngIf="deliverySummary?.addressLine2">{{deliverySummary.addressLine2}}<br /></span>
        <span *ngIf="deliverySummary?.addressLine3">{{deliverySummary.addressLine3}}<br /></span>
        <span *ngIf="deliverySummary?.suburb">{{deliverySummary.suburb}}<br /></span>
        <span *ngIf="deliverySummary?.state">{{deliverySummary.state}}</span> <span *ngIf="deliverySummary?.postcode"> {{deliverySummary.postcode}}</span>
        <br>
        <span>Desired dispatch date: {{deliverySummary.dispatchDate}}</span>
      </div>
    </ng-template>

  </div>
</div>